import styled from '@emotion/styled';
import { OL_COLOUR_BLACK_55_HEX } from 'src/web/components/Style/colours';

export const RadioOptionSubLabel = styled('div')({
  color: OL_COLOUR_BLACK_55_HEX,
});
